<script>import { twMerge } from 'tailwind-merge';
import Divider from './Divider.svelte';
import { get_current_component } from 'svelte/internal';
import { forwardEventsBuilder, useActions } from '../../actions';
export let use = [];
import { exclude } from '../../utils/exclude';
const forwardEvents = forwardEventsBuilder(get_current_component());
export let href;
const defaultClass = 'flex items-center text-secondary-content hover:text-primary';
$: finalClass = twMerge(defaultClass, $$props.class);
</script>

<li class="stwui-breadcrumbs-crumb">
	<div
		class={finalClass}
		use:useActions={use}
		use:forwardEvents
		{...exclude($$props, ['use', 'class'])}
	>
		{#if $$slots.divider}
			<slot name="divider" />
		{:else}
			<Divider />
		{/if}
		<a {href} class="flex items-center {$$slots.icon ? 'pl-3' : ''}">
			<slot name="icon" />
			<slot name="label" />
			<slot />
		</a>
	</div>
</li>
